import { useParams } from "react-router-dom"
import {
  FaEnvelope,
  FaPhoneAlt,
  FaUniversity,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaFlask,
  FaBook,
  FaBookOpen,
  FaLayerGroup,
  FaTrophy,
  FaUsers,
  FaExternalLinkAlt,
  FaFilePdf,
  FaCalendarAlt,
  FaIdBadge
} from "react-icons/fa"

import facultyProfiles from "../../data/departmentalData/facultyProfiles"
import "./FacultyProfilePage.css"
import Footer from "../../components/Homepage/Footer/Footer"
import Navbar from "../../components/Homepage/Navbar/Navbar"

const FacultyProfilePage = () => {
  const { id } = useParams()
  const faculty = facultyProfiles.find(f => f.id === id)

  if (!faculty) {
    return <div className="fp-notfound">Faculty Profile Not Found</div>
  }

  return (
    <>
      <Navbar />

      <div className="fp-page">

        {/* ================= HERO ================= */}
        <section className="fp-hero">
          <img src={faculty.photo} alt={faculty.name} />

          <div className="fp-hero-info">
            <h1>{faculty.name}</h1>
            <h3>{faculty.role}</h3>
            <p>{faculty.department}</p>
            <p className="fp-qual">{faculty.qualification}</p>

            <span className="fp-university">
              <FaUniversity /> {faculty.university}
            </span>
          </div>
        </section>

        {/* ================= PERSONAL INFO ================= */}
        <section className="fp-info-card">
          <div><FaEnvelope /> <span>{faculty.email}</span></div>
          <div><FaPhoneAlt /> <span>{faculty.phone || faculty.mobile}</span></div>
          {faculty.dateOfBirth && (
            <div><FaCalendarAlt /> <span>DOB: {faculty.dateOfBirth}</span></div>
          )}
          {faculty.dateOfJoining && (
            <div><FaIdBadge /> <span>DOJ: {faculty.dateOfJoining}</span></div>
          )}
        </section>

        {/* ================= QUICK STATS ================= */}
        <section className="fp-stats">
          <div>
            <FaChalkboardTeacher />
            <h4>{faculty.experience?.teaching || "—"}</h4>
            <span>Teaching Experience</span>
          </div>

          <div>
            <FaBook />
            <h4>{faculty.publications?.total || faculty.publicationsList?.length || 0}</h4>
            <span>Total Publications</span>
          </div>

          <div>
            <FaUsers />
            <h4>{faculty.memberships?.length || 0}</h4>
            <span>Memberships</span>
          </div>
        </section>

        {/* ================= ABOUT ================= */}
        {faculty.about && (
          <section className="fp-section">
            <h2><FaUserGraduate /> About</h2>
            <p className="fp-about">{faculty.about}</p>
          </section>
        )}

        {/* ================= INFO CARDS ================= */}
        <section className="fp-cards">

          {faculty.education && (
            <div className="fp-card">
              <h3><FaUserGraduate /> Education</h3>
              <ul>
                {faculty.education.map((e, i) => (
                  <li key={i}>{e}</li>
                ))}
              </ul>
            </div>
          )}

          {faculty.experience && (
            <div className="fp-card">
              <h3><FaChalkboardTeacher /> Experience</h3>
              <p>Teaching: {faculty.experience.teaching}</p>
              <p>Research: {faculty.experience.research}</p>
            </div>
          )}

          {faculty.specialization && (
            <div className="fp-card">
              <h3><FaFlask /> Specialization</h3>
              <ul>
                {faculty.specialization.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </div>
          )}
        </section>

        {/* ================= PUBLICATIONS SUMMARY ================= */}
        {faculty.publications && (
          <section className="fp-section">
            <h2><FaBook /> Publications Summary</h2>

            <div className="fp-publication-summary">

              {faculty.publications.journalsInternational !== undefined && (
                <div className="fp-pub-card">
                  <FaBookOpen />
                  <h4>{faculty.publications.journalsInternational}</h4>
                  <span>International Journals</span>
                </div>
              )}

              {faculty.publications.journalsNational !== undefined && (
                <div className="fp-pub-card">
                  <FaBookOpen />
                  <h4>{faculty.publications.journalsNational}</h4>
                  <span>National Journals</span>
                </div>
              )}

              {faculty.publications.conferences !== undefined && (
                <div className="fp-pub-card">
                  <FaLayerGroup />
                  <h4>{faculty.publications.conferences}</h4>
                  <span>Conference Papers</span>
                </div>
              )}

              {faculty.publications.booksChapters !== undefined && (
                <div className="fp-pub-card">
                  <FaBook />
                  <h4>{faculty.publications.booksChapters}</h4>
                  <span>Book Chapters</span>
                </div>
              )}

            </div>
          </section>
        )}

        {/* ================= PUBLICATIONS TABLE ================= */}
        {/* {faculty.publicationsList?.length > 0 && (
          <section className="fp-section">
            <h2><FaBook /> Research Publications</h2>

            <div className="fp-table-wrapper">
              <table className="fp-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Year</th>
                    <th>Title</th>
                    <th>Authors</th>
                    <th>Journal</th>
                    <th>Type</th>
                    <th>DOI</th>
                  </tr>
                </thead>
                <tbody>
                  {faculty.publicationsList.map((p, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td><span className="fp-year-badge">{p.year}</span></td>
                      <td className="fp-title">{p.title}</td>
                      <td>{p.authors}</td>
                      <td><i>{p.journal}</i></td>
                      <td className="fp-type">{p.type}</td>
                      <td>
                        {p.doi ? (
                          <a href={p.link} target="_blank" rel="noreferrer" className="fp-doi">
                            <FaExternalLinkAlt /> {p.doi}
                          </a>
                        ) : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )} */}

        {/* ================= AWARDS ================= */}
        {faculty.awards && (
          <section className="fp-section">
            <h2><FaTrophy /> Awards & Achievements</h2>
            <ul className="fp-list">
              {faculty.awards.map((a, i) => (
                <li key={i}><FaTrophy /> {a}</li>
              ))}
            </ul>
          </section>
        )}

        {/* ================= MEMBERSHIPS ================= */}
        {faculty.memberships && (
          <section className="fp-section">
            <h2><FaUsers /> Memberships & Professional Activities</h2>
            <ul className="fp-list">
              {faculty.memberships.map((m, i) => (
                <li key={i}>{m}</li>
              ))}
            </ul>
          </section>
        )}

        {/* ================= RESEARCH PROFILES ================= */}
        {faculty.profiles && (
          <section className="fp-section">
            <h2><FaUserGraduate /> Research Profile IDs</h2>

            <div className="fp-profiles">
              {faculty.profiles.orcid && (
                <div className="fp-profile-card">
                  <span className="fp-profile-label">ORCID</span>
                  <a href={`https://orcid.org/${faculty.profiles.orcid}`} target="_blank" rel="noreferrer">
                    {faculty.profiles.orcid}
                  </a>
                </div>
              )}

              {faculty.profiles.vidwan && (
                <div className="fp-profile-card">
                  <span className="fp-profile-label">VIDWAN</span>
                  <span>{faculty.profiles.vidwan}</span>
                </div>
              )}
            </div>
          </section>
        )}

        {/* ================= CTA ================= */}
        <section className="fp-cta">
          {faculty.profiles?.scholar && (
            <a href={faculty.profiles.scholar} target="_blank" rel="noreferrer">
              <FaExternalLinkAlt /> Google Scholar
            </a>
          )}

          {faculty.profilePdf && (
            <a href={faculty.profilePdf} target="_blank" className="fp-pdf-btn">
              <FaFilePdf /> Download Faculty Profile (PDF)
            </a>
          )}
        </section>

      </div>

      <Footer />
    </>
  )
}

export default FacultyProfilePage
